
import { ColorMixin } from '@/mixins';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component
export default class ScoreSelectorV3 extends Mixins(ColorMixin) {
	@Prop() value!: number;
	@Prop({ type: Boolean }) readonly;
	@Prop({ type: String }) label;
	@Prop({ type: Number, default: 10 }) step;

	stepSlider: number;
	mounted() {
		this.stepSlider = this.step;
	}

	onInput(data: number) {
		this.$emit('input', data);
	}
	onChange(data: number) {
		this.$emit('change', data);
	}
	onInputText(data: number) {
		this.stepSlider = 1;
		this.$emit('input', data);
		this.$emit('change', data);
	}
}
